export default __webpack_public_path__ + "static/landing-section-3-img-6-40d210c7df69bdb53da7edc34d7e744d.png";